export const DRAFT_MESSAGE
  = 'Are you sure you want to mark the report as a draft? Clients will lose access to the report from their accounts. This action is reversible, and the report can be re-approved for client access if needed.';
export const APPROVE_MESSAGE
  = 'Are you sure the report is ready to be approved for client access? From now on, the client will be able to access the report from their user account. See Settings > User Management > Invite User. This action is reversible and the report can be marked as a draft again if necessary.';
export const SAVE_LABEL = 'Save';
export const TOGGLE_EDIT_MODE_LABEL = 'Toggle Edit Mode';
export const MARK_AS_DRAFT_LABEL = 'Mark as Draft';
export const APPROVE_FOR_CLIENT_ACCESS_LABEL = 'Approve for Client Access';
export const REPORT_MARKED_AS_DRAFT = 'Report marked as draft';
export const REPORT_APPROVED_FOR_CLIENT_ACCESS = 'Report approved for client access';
